module.exports = __webpack_public_path__ + "static/media/martin_bernstein_rata.afca992c.png";